// extracted by mini-css-extract-plugin
module.exports = {"button":"CircleButton_button__1631z","small":"CircleButton_small__3rrO0","large":"CircleButton_large__3YJwh"};